module.exports = "/assets/data/149a005d1ab4b5a61b95fe507f8049ea-GL12.data.json";